import React, { useEffect, useState, useMemo } from "react";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Dialog, Box } from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import AdminLayout from "../AdminLayout";

const localizer = momentLocalizer(moment);

const SpecialDatesCalendar = () => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const getData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}/admin/specialDates/get`);
      const formatted = response.data.map((item) => ({
        id: item.id,
        title: `${item.first_name} ${item.last_name} - ${item.short_description}`,
        start: new Date(item.date),
        end: new Date(item.date),
        date: item.date,
        first_name: item.first_name,
        last_name: item.last_name,
        phone: item.phone,
        email: item.email,
        short_description: item.short_description,
        notes: item.notes,
      }));
      setEvents(formatted);
    } catch (error) {
      toast.error("Failed to fetch special dates.");
    }
  };
  

  useEffect(() => {
    getData();
  }, []);

  const handleSelectEvent = (event) => {
    setSelectedEvent(event);
    setIsModalOpen(true);
  };

  const calendarConfig = useMemo(() => {
    const today = new Date();
    return {
      defaultDate: today,
      views: { month: true, agenda: true, day: true },
      min: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 8),
      max: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 20),
    };
  }, []);

  const dialogStyle = {
    margin: "auto",
    width: 600,
    maxWidth: "95%",
    zIndex: 10000,
    background: "#fff",
    borderRadius: "8px",
  };

  return (
    <AdminLayout>
      <div style={{ height: "80vh", padding: "20px" }}>
        <Calendar
          localizer={localizer}
          events={events}
          defaultView={Views.MONTH}
          views={calendarConfig.views}
          defaultDate={calendarConfig.defaultDate}
          startAccessor="start"
          endAccessor="end"
          style={{ height: "100%" }}
          onSelectEvent={handleSelectEvent}
          eventPropGetter={() => ({
            style: {
              backgroundColor: "#007bff",
              color: "white",
              borderRadius: "4px",
              padding: "2px 5px",
            },
          })}
        />

        <Dialog open={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <Box sx={dialogStyle}>
            {selectedEvent && (
              <div style={{ padding: 20 }}>
                <b>{moment(selectedEvent.date).format("YYYY-MM-DD")}</b>
                <p>{selectedEvent.short_description}</p>

                <div className="row">
                  <div className="col-sm-6">
                    <label>Customer Name: </label>
                  </div>
                  <div className="col-sm-6">
                    <h5>{selectedEvent.first_name} {selectedEvent.last_name}</h5>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    <label>Customer Phone: </label>
                  </div>
                  <div className="col-sm-6">
                    <h5>{selectedEvent.phone}</h5>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    <label>Customer Email: </label>
                  </div>
                  <div className="col-sm-6">
                    <h5>{selectedEvent.email}</h5>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    <label>Notes: </label>
                  </div>
                  <div className="col-sm-6">
                    <p>{selectedEvent.notes}</p>
                  </div>
                </div>
              </div>
            )}
          </Box>
        </Dialog>
      </div>
    </AdminLayout>
  );
};

export default SpecialDatesCalendar;
